<div class="flex flex-col h-full">
  <div class="flex items-center justify-end">
    <button
      type="button"
      mat-icon-button
      (click)="close()"
      title="Close dialog"
    >
      <mat-icon fontIcon="close" aria-label="close icon"></mat-icon>
    </button>
  </div>
  <app-search-results [initialSearchText]="data?.searchText ?? null"></app-search-results>
</div>
